import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const Verify: React.FC<Props> = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle cx="29.819" cy="29.819" r="29.819" fill="#008AF6" />
            <path d="M20.793 41.7988L42.335 20.2568L58.9136 36.8355L57.5323 40.8397L55.8605 44.5533L53.6733 47.7517L51.2287 50.6925L48.4112 53.2605L45.2539 55.4887L41.5703 57.1907L39.5792 57.8842L37.5799 58.5858L20.793 41.7988Z" fill="url(#paint0_linear_41588_23542)" />
            <g filter="url(#filter0_d_41588_23542)">
                <path fillRule="evenodd" clipRule="evenodd" d="M42.6346 20.5369C41.4473 19.3497 39.5223 19.3497 38.335 20.537L23.2268 35.6452L17.4674 29.8858C16.2801 28.6985 14.3551 28.6985 13.1678 29.8858C11.9805 31.0731 11.9805 32.9981 13.1678 34.1854L21.0513 42.0688C22.2386 43.2561 24.1635 43.2561 25.3508 42.0688C25.379 42.0407 25.4065 42.0121 25.4334 41.9831C25.5633 41.8891 25.6875 41.7836 25.8045 41.6666L42.6346 24.8365C43.8219 23.6492 43.8219 21.7242 42.6346 20.5369Z" fill="#FFC107" />
            </g>
            <defs>
                <filter id="filter0_d_41588_23542" x="6.21876" y="13.5879" width="50.6355" height="42.7" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.63515" dy="3.63515" />
                    <feGaussianBlur stdDeviation="4.84687" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_41588_23542" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_41588_23542" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_41588_23542" x1="31.564" y1="31.0278" x2="51.2287" y2="50.6925" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#0071CA" />
                    <stop offset="1" stopColor="#008AF6" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Verify;

